export default "__VITE_ASSET__BX7tAhgg__"